export default {
  SET_PLACE_CATEGORIES (state, place_categories) {
    state.place_categories = place_categories
  },
  REMOVE_RECORD (state, itemId) {
    const placeCategoryIndex = state.place_categories.findIndex((u) => u.id === itemId)
    state.place_categories.splice(placeCategoryIndex, 1)
  }
}
